import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import DeviceMetricsDoughnutChart from '@/pages/SpaceAnalyticsPage/charts/DeviceMetricsDoughnutChart'
import messages from '@/pages/SpaceAnalyticsPage/DeviceMetricsSection/messages'
import pageMessages from '@/pages/SpaceAnalyticsPage/messages'

const CHART_COLORS = ['#38BD9F', '#E6A03F']

const MemberActivityByDevice = ({ byDeviceData }: any) => {
  return (
    <div className="sub-section">
      <div className="metric-card-subheader">
        <h3>
          <FormattedMessage {...messages.memberActivityByDeviceSectionTitle} />
        </h3>
        <span className="sub-text">
          <FormattedMessage {...messages.memberActivityByDeviceSectionDescription} />
        </span>
      </div>
      {byDeviceData.length > 0 ? (
        <DeviceMetricsDoughnutChart className="doughnut-chart" data={byDeviceData} colors={CHART_COLORS} />
      ) : (
        <p className="flex-center">
          <FormattedMessage {...pageMessages.noActivityMetrics} />
        </p>
      )}
    </div>
  )
}

MemberActivityByDevice.displayName = 'MemberActivityByDevice'

MemberActivityByDevice.propTypes = {
  byDeviceData: PropTypes.array.isRequired
}

export default MemberActivityByDevice
